import { action, props } from 'ts-action';

export const increment = action(
  '[EcgCount] increment',
  props<{ ecgId: string }>(),
);

export const reset = action('[EcgCount] reset');
